import { PropertyType, PropertyValueType } from '@pointorama/potree-shared';
import { ProjectByIdQuery } from '../../types/graphqlTypes';

export interface InitialProperty {
  /** Property identifier (e.g. 'point_position') */
  identifier: string;
  /** Object identifier (e.g. 'annotation_abc') — used as propertyIdentifier in GraphQL */
  objectIdentifier: string;
  value: unknown;
  valueType: PropertyValueType;
  propertyType: PropertyType;
}

export interface CreateAnnotationParams {
  identifier: string;
  type: string;
  groupIdentifier?: string | null;
  initialProperties?: InitialProperty[];
}

/**
 * Build a minimal annotation cache entry matching the lean Annotation type.
 * All other annotation data lives in the reactive property system, not the GraphQL cache.
 */
export function buildAnnotationCacheEntry(
  params: CreateAnnotationParams,
): ProjectByIdQuery['projectById']['state']['annotations'][number] {
  return {
    __typename: 'Annotation' as const,
    identifier: params.identifier,
    type: params.type,
    groupIdentifier: params.groupIdentifier || null,
  } as ProjectByIdQuery['projectById']['state']['annotations'][number];
}
